import TablePagination from '../component/TablePagination';
import { brand } from "../config/brands";
// src/pages/PendingOrders.js
import React, { useEffect, useState } from 'react';
import Layout from '../component/Layout';
import './Categories.css';
import { ArrowUpTrayIcon,  EllipsisVerticalIcon, PencilIcon, PhoneArrowUpRightIcon, PlusIcon, TrashIcon } from '@heroicons/react/24/outline';
import { ApiUrlService } from '../api-library/api-services';
import axios from 'axios';
import AsyncStorage from '@react-native-async-storage/async-storage';
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import jsPDF from "jspdf";
import "jspdf-autotable";

const SubCategories = () => {

  let emptyCategory = {
    subCategoryId: '',
    name: '',
    priority: '',
    image: ''
  }

  const [currentPage, setCurrentPage] = useState(1);
  const rowsPerPage = 12;
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [addModalOpen, setAddModalOpen] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState('');
  const [activeCategory, setActiveCategory] = useState('');
  const [categoryLoading, setCategoryLoading] = useState(true);
  const [loadError, setLoadError] = useState('');
  const [categories, setCategories] = useState([]);
  const [image, setImage] = useState(null);
  const [category, setCategory] = useState(emptyCategory);
  const [categoryName, setCategoryName] = useState("");
  const [priority, setPriority] = useState("");
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [dropdownOpenId, setDropdownOpenId] = useState(null);
  const toggleDropdown = (id) => setDropdownOpenId(dropdownOpenId === id ? null : id);
  const handlePageChange = (page) => page > 0 && page <= totalPages && setCurrentPage(page);
 



  // Inside the component function
const exportToPDF = () => {
  const doc = new jsPDF();
  
  // Adding title to PDF
  doc.text("SubCategories", 20, 20);
  
  // Set up headers for the table
  const headers = ["#", "Name", "Priority", "Image" ];
  
  // Create rows dynamically based on orders
  const rows = paginatedOrders.map(order => [
    order.subCategoryId,
    order.name,
    order.priority,
    order.image
  ]);
  
  // Add the table to the PDF
  doc.autoTable({
    head: [headers],
    body: rows,
    startY: 30, // The Y position where the table starts
  });

  // Save the PDF to the local system
  doc.save("categories.pdf");
};

  const handleDeleteClick = (item) => {
    toggleDropdown(null)
    setSelectedItem(item);
    setShowConfirmModal(true);

  };
  const cancelDelete = () => {
    
    setShowConfirmModal(false);
  };

  const confirmDelete = () => {
   
    handleDeleteCategory(selectedItem);
    
  
  };

 


  const handleDeleteCategory = async (category) =>{
    try {

      var service = apiUrlService.DeleteApi();
      fetch(`${brand.apiBaseUrl}/subCategory/` + category.subCategoryId + '', service).then(res => res.json())
          .then(response => {
              setLoading(false)
              if (response.status === true) {
                toast.success("Sub Category Deleted!");
                  setShowConfirmModal(false);
                  setCategory(emptyCategory);
                  getCategories()
              }else{
       
                toast.error("Error deleting sub category!");
              
              
              }
          })


    } catch (error) {
      toast.error("Error deleting item!");
      console.error("Delete error:", error);
    }
  }

    // Derived states
    const filteredOrders = orders.filter((order) => {
      if (!activeCategory || String(order.category?.categoryId) !== activeCategory) return false;
      const search = searchTerm.toLowerCase();
      return (
        order.name?.toString().toLowerCase().includes(search) ||
        order.subCategoryId?.toString().toLowerCase().includes(search) ||
        order.priority?.toString().toLowerCase().includes(search) 
      );
    });
  
    const totalPages = Math.ceil(filteredOrders.length / rowsPerPage);
  useEffect(() => {
    setCurrentPage(page => Math.min(page, Math.max(1, totalPages)));
  }, [totalPages]);
    const paginatedOrders = filteredOrders.slice(
      (currentPage - 1) * rowsPerPage,
      currentPage * rowsPerPage
    );

    const handleSearchChange = (e) => {
      setSearchTerm(e.target.value);
      setCurrentPage(1); // Reset to first page on search
    };

  const handleImageChange = async (e) => {
    const file = e.target.files[0];
    if (file) {
      setImage(file);
      const formData = new FormData();
      formData.append("file", file);
      try {
        const response = await axios.post(
          `${brand.apiBaseUrl}/saveImage`,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );
        setCategory((prevCategory) => ({
          ...prevCategory,
          image: response.data.data, // Update image URL
        }));
      } catch (error) {
        console.error("Error uploading image:", error.message);
        toast.error("Failed to upload image.");
      }
    }
  };

  const addNewCategory = async () => {
    if (!selectedCategory) { toast.error("Choose a category first."); return; }

    const body =
    {
      "name": categoryName,
      "priority": priority,
      "image": category.image,
      "category":{
        "categoryId": selectedCategory
      }
    }
    var service = apiUrlService.PostApi(body)
    fetch(`${brand.apiBaseUrl}/subCategory`, service).then((response) => response.json())
      .then((response) => {
        setLoading(false)
        if (response.status === true) {
          toast.success("Sub Category Created!");
          setAddModalOpen(false)
          getCategories()
          setCategoryName("")
          setPriority("")
          setImage("")

        }
      })

  }

  const handleCategoryChange = (e) => {
    const selectedCategoryId = e.target.value;
    setSelectedCategory(selectedCategoryId);
   
  };


  const getCategoriesForSub = async () => {
    setCategoryLoading(true);
    try {
      const response = await fetch(`${brand.apiBaseUrl}/category`, apiUrlService.GetApi());
      if (!response.ok) throw new Error('Categories unavailable');
      const body = await response.json();
      if (!Array.isArray(body.data)) throw new Error('Invalid categories');
      const options = body.data.map(item => ({ label: item.name, value: String(item.categoryId) }));
      setCategories(options);
      setActiveCategory(current => options.some(option => option.value === current) ? current : options[0]?.value || '');
    } catch { setLoadError('Could not load categories. Please reload the page to try again.'); }
    finally { setCategoryLoading(false); }
  };

  const handleEditOrder = (item) => {
    if (!selectedCategory) { toast.error("Choose a category first."); return; }

    const body =
    {
      "name": categoryName,
      "priority": priority,
      "image": category.image ? category.image : item.image,
      "category":{
        "categoryId":selectedCategory
      }
    }

    var service = apiUrlService.PutApi(body)
    fetch(`${brand.apiBaseUrl}/subCategory/` + item.subCategoryId + '', service).then((response) => response.json())
      .then((response) => {

        if (response.status === true) {
          toast.success("Sub Category Updated!");
          setIsModalOpen(false)
          setSelectedCategory(null)
          setCategoryName("")
          setPriority("")
          getCategories()
        }
      })
  };

  const handleDeleteItem = (index) => {
    console.log("Delete item at index:", index);
    // Implement the logic to delete the item
    // For example, you can update the items array:
    const updatedItems = selectedOrder.items.filter((_, i) => i !== index);
    setSelectedOrder({ ...selectedOrder, items: updatedItems });
  };

  const apiUrlService = new ApiUrlService()

  useEffect(() => {
    getCategories()
    getCategoriesForSub()

  }, []);

  useEffect(() => {
    if (selectedOrder) {
      setCategoryName(selectedOrder.name || "");
      setPriority(selectedOrder.priority || "");
    }
  }, [selectedOrder]);

  const getCategories = async () => {
    setLoading(true);
    try {
      const response = await fetch(`${brand.apiBaseUrl}/subCategory`, apiUrlService.GetApi());
      if (!response.ok) throw new Error('Subcategories unavailable');
      const body = await response.json();
      if (!Array.isArray(body.data)) throw new Error('Invalid subcategories');
      setOrders(body.data);
    } catch { setLoadError('Could not load subcategories. Please reload the page to try again.'); }
    finally { setLoading(false); }
  };

  const openModal = (order) => {
    toggleDropdown(null)
    setSelectedCategory(String(order.category?.categoryId || activeCategory));
    setCategory(emptyCategory);
    setSelectedOrder(order); // Set the selected order to display its details
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedOrder(null); // Clear selected order when closing the modal
  };


  return (
    <Layout>
      <div className="category-page">
      <ToastContainer />
      <header className="category-header"><p>{brand.displayName.toUpperCase()} / CATALOG</p><h1>Subcategories</h1><span>Choose a category to explore and manage its subcategories.</span></header>
      <div className="subcategory-selector"><label htmlFor="browse-category">Category</label><select id="browse-category" value={activeCategory} disabled={categoryLoading || !categories.length} onChange={event => { setActiveCategory(event.target.value); setSearchTerm(''); setCurrentPage(1); setDropdownOpenId(null); }}>
        {!categories.length && <option value="">{categoryLoading ? 'Loading categories…' : 'No categories available'}</option>}
        {categories.map(item => <option key={item.value} value={item.value}>{item.label}</option>)}
      </select><span>{categories.find(item => item.value === activeCategory)?.label || 'Select a category'} · {filteredOrders.length} subcategories</span></div>
      {loadError && <div className="category-empty" role="alert">{loadError}</div>}
      <div className="category-collection">
        <div className="data-toolbar bg-grey flex justify-between items-center mb-0 w-full border-t border-l pl-3 border-r pr-3 pt-3 border-gray-200">

          <div className="w-1/3 pb-3">
          <input
          type="text"
          value={searchTerm}
          onChange={handleSearchChange}
          placeholder="Search subcategories…" aria-label="Search subcategories"
          className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
        />
          </div>

          <div className="npb-3 flex">
            <button disabled={!activeCategory || categoryLoading} onClick={() => { setSelectedCategory(activeCategory); setCategoryName(''); setPriority(''); setCategory(emptyCategory); setAddModalOpen(true); }}
              className="px-4 py-2 bg-yellow flex mr-5 text-white font-inter text-sm font-sm rounded-lg hover:bg-customColor transition-colors"
            > <PlusIcon className="h-4 w-4 mr-2 mt-0.4" />
              New Sub Category
            </button>
            <button onClick={exportToPDF}
              className="px-4 py-2 bg-yellow flex text-white font-inter text-sm font-sm rounded-lg hover:bg-customColor transition-colors"
            > <ArrowUpTrayIcon className="h-4 w-4 mr-2 mt-0.4" />
              Export
            </button>
          </div>
        </div>
        <div className="category-grid" aria-label="Subcategories" aria-busy={loading}>
          {paginatedOrders.map(order => <article className="category-card" key={order.subCategoryId}>
            <button type="button" className="category-preview" onClick={() => openModal(order)} aria-label={`Edit ${order.name}`}>
              <span className="category-fallback" aria-hidden="true">{order.name?.charAt(0).toUpperCase() || 'C'}</span>
              {order.image && <img key={order.image} src={order.image} alt="" loading="lazy" onError={event => { event.currentTarget.style.display = 'none'; }} />}
            </button>
            <div className="category-info"><div><h2 title={order.name}>{order.name}</h2><span>Priority {order.priority ?? '—'}</span></div>
              <button type="button" className="category-menu-toggle" aria-label={`Actions for ${order.name}`} aria-expanded={dropdownOpenId === order.subCategoryId} onClick={() => toggleDropdown(order.subCategoryId)}><EllipsisVerticalIcon /></button>
            </div>
            {dropdownOpenId === order.subCategoryId && <div className="category-menu"><button onClick={() => openModal(order)}><PencilIcon />Edit subcategory</button><button className="category-delete" onClick={() => { toggleDropdown(null); handleDeleteClick(order); }}><TrashIcon />Delete subcategory</button></div>}
          </article>)}
        </div>
        {!paginatedOrders.length && !loadError && <div className="category-empty" role="status">{loading || categoryLoading ? 'Loading subcategories…' : !activeCategory ? 'Create a category first to add subcategories.' : searchTerm ? 'No subcategories match your search in this category.' : 'No subcategories in this category yet.'}</div>}
        {/* Pagination */}
      <div className="data-pagination bg-grey mb-0 w-full flex justify-between border-t border-l pl-3 border-r pr-3 pt-3 items-center md:flex-row justify-between pt-4">
          <span className="text-sm font-medium">
            Showing {filteredOrders.length ? (currentPage - 1) * rowsPerPage + 1 : 0}-{Math.min(currentPage * rowsPerPage, filteredOrders.length)} of{' '}
            {filteredOrders.length}
          </span>
          <TablePagination currentPage={currentPage} totalPages={totalPages} onPageChange={handlePageChange} />
        </div>
      </div>
      <div className="data-endcap">
       

        {/* Modal */}
        {isModalOpen && selectedOrder && (
          <div className="category-modal-backdrop fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
            <div className="category-modal-panel bg-white rounded-lg shadow-lg p-6">
              <h2 className="text-lg font-semibold mb-4">SubCategory Details</h2>
              <hr className="w-full" style={{ border: "1px solid var(--color-border)", margin: "10px 0" }} />


              <div>

                <label className="block text-sm font-medium text-gray-700 mb-1">Name</label>

                <input
                  type="text"
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg mb-4"
                  placeholder='SubCategory Name'
                  value={categoryName}
                  onChange={(e) => setCategoryName(e.target.value)}
                />

                <label className="block text-sm font-medium text-gray-700 mb-1">Priority</label>
                <input
                  type="text"
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg mb-4"
                  value={priority}
                  onChange={(e) => setPriority(e.target.value)}
                />

<div>
            <label htmlFor="category" className="font-inter text-sm text-gray-700">Category</label>
            <select
              id="category"
              value={selectedCategory}
              onChange={handleCategoryChange}
              className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
            >
              <option value="">Select a category</option>
              {categories.map((category) => (
                <option key={category.value} value={category.value}>
                  {category.label}
                </option>
              ))}
            </select>
          </div>
              </div>



              <div className="flex justify-center space-x-2 pt-10">
                <button
                  className="px-5 py-1 bg-white border font-inter border-gray-700 text-gray-700 text-sm rounded-lg hover:bg-yellow hover:text-white hover:border-white "
                  onClick={() => handleEditOrder(selectedOrder)}
                >
                  SAVE
                </button>
                <button className="px-5 py-1 bg-white font-inter  border border-gray-700 text-gray-700 text-sm  rounded-lg hover:bg-yellow hover:text-white hover:border-white"
                  onClick={closeModal}>
                  CANCEL
                </button>
              </div>
            </div>
          </div>
        )}


        {/* Add Category Modal */}
        {addModalOpen && (
          <div className="category-modal-backdrop fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
            <div className="category-modal-panel bg-white rounded-lg shadow-lg p-6">
              <h3 className="text-lg font-semibold mb-4">Add SubCategory</h3>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">SubCategory Name</label>
                <input
                  type="text"
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg mb-4"
                  placeholder='Sub Category Name'
                  value={categoryName}
                  onChange={(e) => setCategoryName(e.target.value)}
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Priority</label>
                <input
                  type="number"
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg"
                  //value={newQuantity}
                  placeholder='Priority'
                  value={priority}
                  onChange={(e) => setPriority(e.target.value)}
                //onChange={(e) => setNewQuantity(e.target.value)}
                />
              </div>

              <div>
            <label htmlFor="category" className="font-inter text-sm text-gray-700">Category</label>
            <select
              id="category"
              value={selectedCategory}
              onChange={handleCategoryChange}
              className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
            >
              <option value="">Select a category</option>
              {categories.map((category) => (
                <option key={category.value} value={category.value}>
                  {category.label}
                </option>
              ))}
            </select>
          </div>

              <div>
       
              </div>
              <div className="flex justify-end space-x-2 mt-4">
                <button
                  className="px-4 py-2 bg-gray-300 rounded-lg"
                  onClick={() => setAddModalOpen(false)}
                >
                  Cancel
                </button>
                <button
                  className="px-4 py-2 bg-gray-300 rounded-lg"
                  onClick={() => addNewCategory()}
                //onClick={() => handleSaveQuantity(selectedOrder.customer.customerId)}
                >
                  Save
                </button>
              </div>
            </div>
          </div>
        )}

  {/* Confirmation Modal */}
  {showConfirmModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white p-6 rounded-lg shadow-lg">
            <p className="text-lg font-semibold mb-4">
              Are you sure you want to delete this subcategory?
            </p>
            <div className="flex justify-end space-x-4">
              <button
                className="px-4 py-2 bg-gray-400 rounded hover:bg-yellow "
                onClick={cancelDelete}
              >
                No
              </button>
              <button
                className="px-4 py-2 bg-gray-400 rounded hover:bg-yellow"
                onClick={confirmDelete}
              >
                Yes
              </button>
            </div>
          </div>
        </div>
      )}

      </div>
    </div>
    </Layout>
  );
};

export default SubCategories;
